export function FlipIcon({ color = '' }) {
  return (
    <svg
      className="flip-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="22"
      viewBox="0 0 36 22"
      fill="none">
      <path
        d="M14.4567 11.7458C14.8714 11.3312 14.863 10.6605 14.4567 10.2543L10.2379 6.03553C9.8261 5.62364 9.15827 5.62364 8.74638 6.03553C8.33449 6.44742 8.33449 7.11517 8.74638 7.52707L11.1647 9.94532H1.05469C0.472219 9.94532 0 10.4175 0 11C0 11.5825 0.472219 12.0547 1.05469 12.0547H11.1647L8.74638 14.473C8.33449 14.8848 8.33449 15.5526 8.74638 15.9645C9.1582 16.3763 9.82603 16.3764 10.2379 15.9645L14.4567 11.7458Z"
        fill={color || 'white'}
      />
      <path
        d="M13.7109 2.5625H34.9453C35.5278 2.5625 36 2.09028 36 1.50781C36 0.925344 35.5278 0.453125 34.9453 0.453125H13.7109C13.1285 0.453125 12.6562 0.925344 12.6562 1.50781C12.6562 2.09028 13.1285 2.5625 13.7109 2.5625Z"
        fill={color || 'white'}
      />
      <path
        d="M34.9453 6.78125H17.9297C17.3472 6.78125 16.875 7.25347 16.875 7.83594C16.875 8.41841 17.3472 8.89062 17.9297 8.89062H34.9453C35.5278 8.89062 36 8.41841 36 7.83594C36 7.25347 35.5278 6.78125 34.9453 6.78125Z"
        fill={color || 'white'}
      />
      <path
        d="M34.9453 13.1094H17.9297C17.3472 13.1094 16.875 13.5816 16.875 14.1641C16.875 14.7465 17.3472 15.2188 17.9297 15.2188H34.9453C35.5278 15.2188 36 14.7465 36 14.1641C36 13.5816 35.5278 13.1094 34.9453 13.1094Z"
        fill={color || 'white'}
      />
      <path
        d="M34.9453 19.4375H13.7109C13.1285 19.4375 12.6562 19.9097 12.6562 20.4922C12.6562 21.0747 13.1285 21.5469 13.7109 21.5469H34.9453C35.5278 21.5469 36 21.0747 36 20.4922C36 19.9097 35.5278 19.4375 34.9453 19.4375Z"
        fill={color || 'white'}
      />
    </svg>
  );
}

export default FlipIcon;
